import React from 'react';
import { Link } from 'react-router-dom';

import Tooltip from 'react-bootstrap/Tooltip'
import ProgressBar from 'react-bootstrap/ProgressBar';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

import '../css/Components.css';

// const radius = 30;

const Title = ({head, title, progress, to, restricted}) => {

	return(
		<>
		{restricted
		?
			<OverlayTrigger
				placement="top"
				delay={{ show: 5, hide: 100 }}
				overlay= {<Tooltip>Please complete 30% of the previous chapter first.</Tooltip>}
			>
			<div className='titleCard restrictedTitle'>
				<div className="innerCard">
					<p style={{fontSize:'85%', marginBottom:'0px'}}>{head}: <span dangerouslySetInnerHTML={{__html: title }} />
					</p>
				</div>
				<ProgressBar now={progress} label={`${progress}%`}/>
			</div>
			</OverlayTrigger>
		:
			<Link to={to} >
			<div className='titleCard'>
				<div className="innerCard">
					<p style={{fontSize:'85%', marginBottom:'0px'}}>{head}: <span dangerouslySetInnerHTML={{__html: title }} />
					</p>
				</div>
				<ProgressBar now={progress} label={`${progress}%`}/>
			</div>
			</Link>	
		}
		</>
	);
};

export default Title;